import React from "react"
import { Link } from "react-router-dom"
import { Card, CardBody, Col, Row } from "reactstrap"
import Breadcrumbs from "components/Common/Breadcrumb"
import { useTranslation } from "react-i18next"
import { getBrandOrdersBasePath } from "hooks/useAssignedBrands"

const OrdersBrandPicker = ({ brands = [] }) => {
  const { t } = useTranslation()

  return (
    <>
      <Breadcrumbs title={t("Orders")} breadcrumbItem={t("Orders")} />
      <Row>
        {brands.map(brand => (
          <Col lg={4} md={6} key={brand.brandId}>
            <Card>
              <CardBody>
                <h5>{brand.displayName || brand.brandName}</h5>
                <p className="text-muted mb-3">
                  {brand.integrationCode} · {brand.cartType}
                </p>
                <Link
                  className="btn btn-primary"
                  to={getBrandOrdersBasePath(brand.brandId)}
                >
                  {t("View Orders")}
                </Link>
              </CardBody>
            </Card>
          </Col>
        ))}
      </Row>
    </>
  )
}

export default OrdersBrandPicker
